import React, { useState, useRef } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import emailjs from "emailjs-com";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import the CSS for React Toastify
import { useLanguage } from "../../Context/LanguageContext";

const JobModal = ({ show, handleClose }) => {
  const { t } = useLanguage();
  const { language } = useLanguage();
  const formRef = useRef(null); // Create a reference for the form

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    location: "", // Initialize 'location' here
    message: "",
    // file: null, // To store the uploaded file
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePhoneChange = (phone) => {
    const countryCode = phone.replace(/\D/g, "").slice(0, 2); // Extract first 2 digits as country code
    const phoneNumber = phone.replace(/\D/g, "").slice(2); // Extract remaining digits

    setFormData((prev) => ({
      ...prev,
      phone: `+${countryCode} ${phoneNumber}`, // Format as +CC XXXXXXXX
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0]; // Get the first file selected
    setFormData((prev) => ({ ...prev, file }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    // Send email using EmailJS and the form reference
    emailjs
      .send(
        "service_q5eshtd",
        "jksel_profile",
        {
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          message: formData.message,
          location: formData.location,
        },
        "0PTcBmJtp3qKmu1ph"
      )

      .then(
        (response) => {
          toast.success("Your resume is submitted!"); // Show success toast
        },
        (err) => {
          toast.error("Failed to send your resume. Please try again."); // Show error toast
        }
      )
      .finally(() => {
        // Reset form data
        setFormData({
          name: "",
          email: "",
          phone: "",
          location: "", // Reset location
          message: " ",
          // file: null, // Reset file
        });
        handleClose(); // Close the contact modal
      });
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t.apply}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form ref={formRef} onSubmit={handleSubmit}>
            <Form.Group controlId="formName">
              <Form.Label>
                {t.fullName} <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder={t.fullNamePlaceholder}
                required
              />
            </Form.Group>

            <Form.Group controlId="formEmail" className="mt-3">
              <Form.Label>
                {t.email} <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder={t.emailPlaceholder}
                required
              />
            </Form.Group>

            <Form.Group controlId="formPhone" className="mt-3">
              <Form.Label>
                {t.phone} <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <PhoneInput
                country={language === "ko-KR" ? "kr" : "in"}
                value={formData.phone}
                onChange={handlePhoneChange}
                inputStyle={{ width: "100%" }}
                required
                placeholder={t.phonePlaceholder}
              />
            </Form.Group>

            <Form.Group controlId="formLocation" className="mt-3">
              <Form.Label>{t.curLocation}</Form.Label>
              <Form.Control
                type="text"
                name="location"
                value={formData.location}
                onChange={handleChange}
                placeholder={t.locationPlaceholder}
                // required
              />
            </Form.Group>

            {/* File Upload Field */}
            {/* <Form.Group controlId="formFile" className="mt-3">
              <Form.Label>
                {t.resume}
                <span style={{ color: "red" }}></span>
              </Form.Label>
              <Form.Control
                type="file"
                name="file"
                onChange={handleFileChange}
                accept=".pdf,.doc,.docx"
              />
            </Form.Group> */}

            <Form.Group controlId="formMessage" className="mt-3">
              <Form.Label>
                Resume Link <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                as="textarea"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows={3}
                placeholder="Please provide the resume link here"
                required
              />
            </Form.Group>

            <Button variant="primary" type="submit" className="mt-3">
              {t.submit}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
      />
    </>
  );
};

export default JobModal;
